import { Typography } from '@carrier-io/air-react';
import { Align, TypographyColor, Variant } from 'constants/componentEnums';
import { isUploadingDisabled, ProjectOnboardingStatus } from 'store/models/Project';

enum StatusMessages {
  CERT_ADDED = 'Your certificate has already been added',
  CONNECTED = 'Your certificate has already been connected',
}

interface CertificateStatusProps {
  status: ProjectOnboardingStatus;
}

const disabledUploadMessage = 'The project status does not allow certificate uploads';

const CertificateStatus = ({ status }: CertificateStatusProps) => {
  const isDisabled = isUploadingDisabled(status);

  return (
    <Typography
      color={isDisabled ? TypographyColor.Error.Main : TypographyColor.Success.Main}
      variant={Variant.Body1}
      align={Align.Center}
    >
      {isDisabled
        ? disabledUploadMessage
        : StatusMessages[status as keyof typeof StatusMessages] || 'Certificate Status'}
    </Typography>
  );
};

export default CertificateStatus;
